import React from "react";
import "./style.css";

const Home = () => {
  return <div className="content-height">Ini Home Page</div>;
};

export default Home;
